export default ($el) =>
  ({
    autoLocationFields: false,
    isLoading: true,
    regionSelected: false,
    areasLabel: 'State',
    areasSelected: [],
    watchRegion: false,
    areas: '',
    initForm() {
      this.fetchAreas()
      const areasField = document.querySelectorAll(
        '[data-select-areas]',
      )
      const regionField = document.querySelectorAll(
        '[data-select-region]',
      )
      if (areasField.length && regionField.length) {
        this.watchRegion = true
      }
    // check for state and region fields
    },
    changeRegion($event) {
      if (!this.watchRegion) {
        return false
      }
      const { currentTarget } = $event
      const currentRegion = currentTarget.value
      const currentAreas = this.areas[currentTarget.value]
      if (
        typeof currentAreas !== 'undefined' &&
                currentAreas.length > 0
      ) {
        this.handleSelectUpdate(currentAreas)
        this.handleLabelUpdate(currentRegion)
        this.toggleStateRequired(true)
      } else {
        this.toggleStateRequired(false)
      }
      return true
    },

    toggleStateRequired(required) {
      const stateSelect = document.querySelectorAll(
        '[data-select-areas]',
      )
      if (required) {
        stateSelect.forEach((element) => {
          element.required = true
          element.classList.remove('hidden')
          this.regionSelected = true
        })
      } else {
        stateSelect.forEach((element) => {
          element.required = false
          element.classList.add('hidden')
          this.areasLabel = ''
          this.regionSelected = false
        })
      }
    },
    findFields() {
      this.autoLocationFields = true
    },
    handleSelectUpdate(currentAreas) {
      const areasArray = []
      Object.keys(currentAreas).forEach((key) => {
        if (currentAreas[key]) {
          areasArray.push(currentAreas[key])
        }
      })

      this.areasSelected = areasArray
    },
    handleLabelUpdate(region) {
      if (region === 'United States') {
        this.areasLabel = 'State'
      } else if (region === 'Canada') {
        this.areasLabel = 'Province'
      } else if (region === 'Europe' || region === 'Asia') {
        this.areasLabel = 'Country'
      } else {
        this.areasLabel = ''
        console.warn(`no label for ${region}`)
      }
    },
    fetchAreas() {
      fetch('/api/areas.json')
        .then((res) =>
          res.json())
        .then((data) => {
          this.isLoading = false
          this.areas = data
        })
    },
  })
